import classNames from '@/utils/classNames';
import type { FCC } from 'react-fc';
import styles from './BadgeList.module.css';

export const BadgeList: FCC = ({ className, children }) => (
    <div className={classNames(className, styles.badgeList)}>{children}</div>
);
